/**
 * Маленький спільний сигнал: чи відкритий зараз попап активації підписки
 * (SubscriptionActivatedModal). InstructionOverlay підписується й НЕ
 * показується, поки попап активації відкритий — щоб інструкція стартувала
 * лише ПІСЛЯ того, як юзер закрив попап про підписку (юзер 2026-06-15:
 * «спочатку попап підписки, після виходу — інструкція, не паралельно»).
 *
 * Module-level (не React-state) — щоб два незалежні root-компоненти
 * (Watcher і Overlay) бачили один прапор без спільного провайдера.
 * Той самий патерн, що maintenance/onboarding listeners у api/client.ts.
 */

let _open = false;
const subs = new Set<(open: boolean) => void>();

export function setActivationModalOpen(open: boolean): void {
  if (_open === open) return;
  _open = open;
  subs.forEach((fn) => fn(open));
}

export function isActivationModalOpen(): boolean {
  return _open;
}

export function subscribeActivationModal(fn: (open: boolean) => void): () => void {
  subs.add(fn);
  fn(_open);
  return () => {
    subs.delete(fn);
  };
}
